// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`


if (use_bumpmap){
	normal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd(), faceDirection );
} else {

	#ifdef OBJECTSPACE_NORMALMAP

	if (tpmData.useTpmNormalMap)
		normal = triplanar_mapping( normalMap, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, tpmData.normalTpmScale ).xyz * 2.0 - 1.0;
	else {
		normal = texture2D( normalMap, normalMapUv ).xyz * 2.0 - 1.0; // overrides both flatShading and attribute normals
	}

	#ifdef FLIP_SIDED

		normal = - normal;

	#endif

	#ifdef DOUBLE_SIDED

		normal = normal * faceDirection;

	#endif

	normal = normalize( normalMatrix * normal );

#elif defined( TANGENTSPACE_NORMALMAP )


	vec3 mapN;
	if (tpmData.useTpmNormalMap)
		mapN = triplanar_mapping( normalMap, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, normalTpmScale ).xyz * 2.0 - 1.0;
	else {	
		mapN = texture2D( normalMap, normalMapUv ).xyz * 2.0 - 1.0; // overrides both flatShading and attribute normals
	}
	
	mapN.xy *= normalScale;

	#ifdef USE_TANGENT

		normal = normalize( vTBN * mapN );

	#else

		normal = perturbNormal2Arb( -vViewPosition, normal, mapN, faceDirection );

	#endif

#endif
}
`;